export default state => state.vod.legacy.data;
